import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import { useSelectContext } from "./context";
import { SelectItem } from "./SelectItem";

export const SelectContent = () => {
  const { t } = useTranslation();
  const { options, contentClassName, maxHeight } = useSelectContext();
  return (
    <div
      className={cn(`overflow-auto p-1 outline-none`, contentClassName)}
      style={{ maxHeight }}
    >
      {options.map((option, index) => {
        return <SelectItem key={option.id} option={option} index={index} />;
      })}

      {options.length === 0 && (
        <div className="p-2 text-neutral-500 text-sm">
          {t("select.noResults")}
        </div>
      )}
    </div>
  );
};
